import GravityAdapter from 'teacher-ui-client/adapters/gravity/v3-adapter'
import { join } from 'teacher-ui-client/utils/uri'

export default class GravitySchoolStatisticsAdatper extends GravityAdapter {
  urlForFindRecord(schoolId: string, modelName: string) {
    const { host, namespace } = this

    const path = this.pathForType(modelName)

    return join(host, namespace, 'schools', schoolId, path).href
  }

  pathForType(_modelName: string) {
    return 'statistics'
  }
}
